import { paymentMethod } from 'constants/tripla'
import { checkIfUnderGMOMaintenance } from 'utilities/creditCardMaintenance'

const state = {
  guessedCurrency: '',
  detectedCurrency: '',
  selectedCurrency: '',
  temporaryCurrency: '',
  isMcpAllowedCardBrand: true,
  mcpByLocaleAllowed: false
}

const getters = {
  isMcpEnabled: (_, __, rootState, rootGetters) => {
    const whitelist = new Set((process.env.ENABLE_MCP_BRAND_IDS || '').split(','))
    const blacklist = new Set((process.env.DISABLE_MCP_BRAND_IDS || '').split(','))
    const isFromBw3 = rootGetters['booking/getIsFromBw3']
    const brandId = String(rootGetters['setting/getBrandID'])

    const isFeatureFlagEnabled =
      whitelist.has(brandId) || (whitelist.has('all') && !blacklist.has(brandId))
    const isBrandEnabled = !!rootState.setting.init?.mcp_enabled
    const isUnderMaintenance = checkIfUnderGMOMaintenance()
    return isFeatureFlagEnabled && !isFromBw3 && isBrandEnabled && !isUnderMaintenance
  },
  selectedCurrency: (state, _, __, rootGetters) => {
    return (
      state.temporaryCurrency ||
      state.selectedCurrency ||
      state.detectedCurrency ||
      state.guessedCurrency ||
      rootGetters['setting/getCurrency']?.code
    )
  },
  dropdownSelectedCurrency: (state) => {
    return state.selectedCurrency
  },
  detectedCurrency: (state) => {
    return state.detectedCurrency
  },
  isMcpMode: (_, getters, rootState, rootGetters) => {
    const isOtherCurrencySelected =
      rootGetters['setting/getCurrency']?.code !== getters.selectedCurrency
    const isMcpReservation = !!rootGetters['booking/getReservationDetails']?.mcp_currency
    const isReservationFromSameFacility =
      !rootGetters['booking/getReservationDetails']?.hotel?.id ||
      rootGetters['booking/getReservationDetails']?.hotel?.id === rootGetters['setting/getHotelId']
    return (
      ((getters.isMcpEnabled && isReservationFromSameFacility) || isMcpReservation) &&
      isOtherCurrencySelected
    )
  },
  temporaryCurrency: (state) => {
    return state.temporaryCurrency
  },
  isMcpAllowedCardBrand: (state) => {
    return state.isMcpAllowedCardBrand
  },
  isMcpByLocaleAllowed: (state) => {
    return state.mcpByLocaleAllowed
  },
  isCurrencyDifferent: (_, getters, __, rootGetters) => {
    return getters.selectedCurrency !== rootGetters['setting/getCurrency'].code
  }
}

const mutations = {
  setGuessedCurrency: (state, payload) => {
    state.guessedCurrency = payload
  },
  setDetectedCurrency: (state, payload) => {
    state.detectedCurrency = payload
  },
  setSelectedCurrency: (state, payload) => {
    state.selectedCurrency = payload
  },
  togglePayment: (state, { method, isMcpAllowedCardBrand, originalCurrency }) => {
    const isAllowedMethod = method === paymentMethod.CreditCard && isMcpAllowedCardBrand
    state.isMcpAllowedCardBrand = isMcpAllowedCardBrand
    state.temporaryCurrency = isAllowedMethod ? '' : originalCurrency
  },
  setTemporaryCurrency: (state, currency) => {
    state.temporaryCurrency = currency
  },
  setIsMcpAllowedCardBrand: (state, currency) => {
    state.isMcpAllowedCardBrand = currency
  },
  setMcpByLocaleAllowed: (state, isAllowed) => {
    state.mcpByLocaleAllowed = isAllowed
  }
}

const actions = {
  setGuessedCurrency: ({ commit }, payload) => {
    commit('setGuessedCurrency', payload)
  },
  setDetectedCurrency: ({ commit }, payload) => {
    commit('setDetectedCurrency', payload)
  },
  setSelectedCurrency: ({ commit }, payload) => {
    commit('setSelectedCurrency', payload)
  },
  setIsMcpAllowedCardBrand: ({ commit }, payload) => {
    commit('setIsMcpAllowedCardBrand', payload)
  },
  setMcpByLocaleAllowed: ({ commit }, payload) => {
    commit('setMcpByLocaleAllowed', payload)
  },
  togglePayment: ({ commit, rootGetters }, { method, isMcpAllowedCardBrand }) => {
    commit('togglePayment', {
      method,
      isMcpAllowedCardBrand,
      originalCurrency: rootGetters['setting/getCurrency']?.code
    })
  },
  setTemporaryCurrency: ({ commit }, currency) => {
    commit('setTemporaryCurrency', currency)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
